import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BrowserView, MobileView } from "react-device-detect";
import { ArrowLeft, Search, ShoppingCart, User } from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../../../assets/svgImages/svgImages";
import { useAuth } from "../../../contexts/authContext";
import { getAuthCredentials } from "../../../utils/auth-utils";
import SearchBox from "../../searchBox/SearchBox";
import "./header.scss";
import UserProfileModal from "./userProfileModal";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const Header = () => {
  const query = useQuery();
  const hasId = query.get("id") !== null;
  const status = query.get("status") !== null;
  const [userModalShow, setUserModalShow] = useState(false);
  const { details, customerUuid } = getAuthCredentials();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();
  const { setShopPageSearchValue } = useAuth();
  const [showSearchBox, setShowSearchBox] = useState(false);
  const {cartItems, setCartItems} = useAuth();

  const onSearch = (query: string | null) => {
    if (query || query?.length === 0) {
      setShopPageSearchValue(query);
    }
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <header>
        <div className="navbar fixed-top">
          <div className="container">
            <div
              className={`navbar-nav ${
                !localStorage.getItem("card-item") &&
                !customerUuid &&
                location.pathname !== "/shop"
                  ? `justify-content-center`
                  : ``
              }`}
            >
              <div className="navbar-logo">
                <Logo />
              </div>
              {(location.pathname === "/shop" ||
                localStorage.getItem("card-item") ||
                customerUuid) && (
                <div className="header-links">
                  {customerUuid && !status && details?.userName && (
                    <Link
                      to={"#"}
                      onClick={() => setUserModalShow(true)}
                      className="user-name nav-link"
                    >
                      {windowWidth < 420 ? (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip
                              id={`tooltip-rd`}
                              style={{ position: "fixed" }}
                            >
                              {details?.userName}
                            </Tooltip>
                          }
                        >
                          <User size={26} />
                        </OverlayTrigger>
                      ) : (
                        <User size={26} />
                      )}
                      <h5 className="u-name">{details?.userName}</h5>
                    </Link>
                  )}

                  {location.pathname === "/shop" && (
                    <div>
                      <MobileView>
                        <div className="d-md-none d-block">
                          {!showSearchBox && (
                            <button
                              className="search-btn"
                              aria-label="Open search"
                              onClick={() => setShowSearchBox(true)}
                            >
                              <Search size={24}></Search>
                            </button>
                          )}

                          {showSearchBox && (
                            <div className="search-box-mobile">
                              <div
                                className="back-button"
                                onClick={() => setShowSearchBox(false)}
                              >
                                <ArrowLeft size={26}></ArrowLeft>
                              </div>
                              <SearchBox
                                onSearch={(searchTerm) => onSearch(searchTerm)}
                              />
                            </div>
                          )}
                        </div>
                      </MobileView>

                      <BrowserView>
                        <div className="d-md-block d-none">
                          {" "}
                          <SearchBox onSearch={onSearch} />
                        </div>
                      </BrowserView>
                    </div>
                  )}
                  {(hasId || location.pathname === "/shop") &&
                    cartItems != 0 && (
                      <Link
                        to={"./cart"}
                        className={`cart-link nav-link ${
                          !customerUuid ? "separator-remover" : ``
                        }`}
                      >
                        <span>{cartItems}</span>
                        <ShoppingCart size={26} />
                      </Link>
                    )}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* User Profile Modal */}
      <UserProfileModal
        show={userModalShow}
        userProfileHide={() => setUserModalShow(false)}
      />
    </>
  );
};

export default Header;
